import { render, staticRenderFns } from "./listOfferedCourse.vue?vue&type=template&id=bea4b41e&"
import script from "./listOfferedCourse.vue?vue&type=script&lang=js&"
export * from "./listOfferedCourse.vue?vue&type=script&lang=js&"
import style0 from "./listOfferedCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports